import React, { useState, useEffect } from "react";
import { useInsertName } from "./utils/helpers";

const ContactIntroSection = ({ onTypingDone, animate = true }) => {
  const name = useInsertName();
  const line = `$ sag hallo, ${name}`;
  const [chars, setChars] = useState(animate ? 0 : line.length);
  const done = chars >= line.length;

  useEffect(() => {
    setChars(animate ? 0 : line.length);
  }, [animate, line.length]);

  useEffect(() => {
    if (!animate) {
      onTypingDone?.();
      return;
    }

    if (chars < line.length) {
      const t = setTimeout(() => setChars((c) => c + 1), 70);
      return () => clearTimeout(t);
    }
    // Headline fertig — kurze Pause, dann Info-Terminal starten
    const t = setTimeout(() => onTypingDone?.(), 800);
    return () => clearTimeout(t);
  }, [chars, line.length, onTypingDone, animate]);

  return (
    <div className="pt-32 pb-8 sm:pt-36 sm:pb-12 md:pt-40 md:pb-16">
      <div className="container mx-auto text-center px-6 max-w-4xl font-mono">
        <h1 className="text-xl sm:text-2xl md:text-3xl text-[#EFEBDC] mb-4 leading-relaxed">
          {line.slice(0, chars)}
          {!done && (
            <span className="inline-block w-[3px] h-[1em] bg-[#AC8E66] ml-0.5 align-middle animate-cursor-blink" />
          )}
        </h1>
        <p className="text-xs sm:text-sm text-[#EFEBDC]/40 max-w-2xl mx-auto">
          <span className="text-[#AC8E66]/60">&gt;</span> ob fragen zu projekten oder einfach nur fuer ein moin.
        </p>
      </div>
    </div>
  );
};

export default ContactIntroSection;
